<template>
  <div class="ocppCnae">
      <alter-form :customeButton="true" ref="alterform" :watchImageVisible="false" :modifyData="data" @formSubmit="formSubmit" :formData="formData"></alter-form>
  </div>
</template>

<script>
// 组件
import alterForm from '@/components/alterForm'
// 接口
import jsonData from '../jsonData'

export default {
  name: 'ocpp',
  components: {
    alterForm
  },
  props: ['data'],
  data () {
    return {
      modifyData: {},
      formData: jsonData.formData_ocpp
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    formSubmit (data) {
      const obj = JSON.parse(JSON.stringify(data))
      this.$emit('tabChange', obj, 'ocpp')
    }
  }
}
</script>

<style lang="scss" scope>
.ocppCnae::after{
    content:'';
    display:block;
    clear:both;
}
</style>
